import { assertUnreachable } from "../../admin/shared/functions/assert-unreachable";
import {
  FilterType,
  SelectorOption,
} from "../../shared/components/filtering/filter.interfaces";
import { SelectorOptionsService } from "../../shared/components/filtering/selector-options.service";
import { Page } from "../shared/domain/models/page";
import { GetCampaignOptionsByIdsInteractor } from "./interactors/get-campaign-options-by-ids.interactor";
import { GetCreatorOptionsByIdsInteractor } from "./interactors/get-creator-options-by-ids.interactor";
import { GetPublicationTypeOptionsByIdsInteractor } from "./interactors/get-publication-type-options-by-ids.interactor";
import { GetPublisherOptionsByIdsInteractor } from "./interactors/get-publisher-options-by-ids.interactor";
import { GetTimePeriodOptionsByIdsInteractor } from "./interactors/get-time-period-options-by-ids.interactor";

export interface GetOptionsByIdInteractor {
  execute(ids: number[] | string[]): Promise<Page<SelectorOption>>;
}

export class OptionsByIdComponent {
  public static provideGetOptionsInteractorByType(
    type: FilterType,
    selectorOptionsService: SelectorOptionsService,
  ): GetOptionsByIdInteractor {
    switch (type) {
      case FilterType.Campaign:
        return OptionsByIdComponent.provideGetCampaignOptionsByIdsInteractor(
          selectorOptionsService,
        );
      case FilterType.Creator:
        return OptionsByIdComponent.provideGetCreatorOptionsByIdsInteractor(
          selectorOptionsService,
        );
      case FilterType.Publisher:
        return OptionsByIdComponent.provideGetPublisherOptionsByIdsInteractor(
          selectorOptionsService,
        );
      case FilterType.PublicationTemplateType:
        return OptionsByIdComponent.provideGetPublicationTypeOptionsByIdsInteractor();
      case FilterType.TimePeriod:
        return OptionsByIdComponent.provideGetTimePeriodOptionsByIdsInteractor();
      default:
        return assertUnreachable(type as never);
    }
  }

  public static provideGetCampaignOptionsByIdsInteractor(
    selectorOptionsService: SelectorOptionsService,
  ): GetCampaignOptionsByIdsInteractor {
    return new GetCampaignOptionsByIdsInteractor(selectorOptionsService);
  }

  public static provideGetCreatorOptionsByIdsInteractor(
    selectorOptionsService: SelectorOptionsService,
  ): GetCreatorOptionsByIdsInteractor {
    return new GetCreatorOptionsByIdsInteractor(selectorOptionsService);
  }

  public static provideGetPublisherOptionsByIdsInteractor(
    selectorOptionsService: SelectorOptionsService,
  ): GetPublisherOptionsByIdsInteractor {
    return new GetPublisherOptionsByIdsInteractor(selectorOptionsService);
  }

  public static provideGetPublicationTypeOptionsByIdsInteractor(): GetPublicationTypeOptionsByIdsInteractor {
    return new GetPublicationTypeOptionsByIdsInteractor();
  }

  public static provideGetTimePeriodOptionsByIdsInteractor(): GetTimePeriodOptionsByIdsInteractor {
    return new GetTimePeriodOptionsByIdsInteractor();
  }
}
